var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.583 65.7083C17.3951 65.7083 3.45801 51.7713 3.45801 34.5833C3.45801 17.3954 17.3951 3.45834 34.583 3.45834",
    stroke: "#51ACED",
    strokeWidth: 6.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "6.92 13.83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.583 3.45834C51.7709 3.45834 65.708 17.3954 65.708 34.5833C65.708 51.7713 51.7709 65.7083 34.583 65.7083",
    stroke: "#51ACED",
    strokeWidth: 6.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.583 48.4167V22.4792",
    stroke: "#51ACED",
    strokeWidth: 6.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6869 34.5834L34.5827 22.4792L22.4785 34.5834",
    stroke: "#51ACED",
    strokeWidth: 6.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadingIcon);
export default __webpack_public_path__ + "static/media/uploading-icon.323d0d138278ec3035d0e0a598eb431b.svg";
export { ForwardRef as ReactComponent };